import React from 'react';

import { LinearProgress } from '@mui/material';

const Progress: React.FC = () => {
  return (
    <div>
      <LinearProgress />
    </div>
  );
};

export default Progress;
